import $ from 'jquery';
import UI from 'root/ui';
import Cache from 'root/cache';
import Constants from 'root/constants';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';
import View_Emoji from 'view/emoji';
import Dnd_File_Uploader from 'root/module/dnd_file_uploader';
import View_Comment_Template from 'view/comment_template';

export default View.extend({
    is_public: true,
    is_access_checkbox_disabled: false,

    attachment_info: {},

    views: {
        emoji: {},
    },

    events: {
        'paste .message-editor'                                : 'onPaste',
        'keyup .message-editor'                                : 'onKeyup',
        'click .message-editor'                                : 'onStoreSelection',
        'click .comment-status-launcher input[type="checkbox"]': 'onTogglePublic',
        'click .emoji-launcher'                                : 'onToggleEmoji',
        'click .attach-launcher'                               : 'onAttachFile',
        'click .attachment-remove'                             : 'onRemoveAttachment',
        'click .attachment-preview-video'                      : 'onPreviewVideoAttachment',
        'click .editor-submit'                                 : 'onSubmit',
        'click .comment-template-button-dropdown'              : 'onToggleCommentTemplate',
    },

    dom_handlers: {
        onToggleEmoji: function(e) {
            if (!(this.views.emoji instanceof View_Emoji)) {
                this.views.emoji = new View_Emoji({
                    onSelect: this.onEmojiSelect.bind(this),
                    launcher: this.$el.find('.emoji-launcher')
                });
                this.views.emoji.render().$el.hide().appendTo(this.$el.find('.region-emoji'));
                this.views.emoji.load();
            }

            this.views.emoji.toggle();
        },

        onAttachFile: function() {
            Util.uploadFile(10, function(error, file_name, file_type, file_content) {
                if (error) {
                    UI.error(error);
                    return;
                }

                this.renderAttachment(file_name, file_type, file_content);
            }.bind(this));
        },

        onRemoveAttachment: function() {
            this.resetAttachment();
        },

        onPreviewVideoAttachment: function(e) {
            if ($(e.target).hasClass('attachment-remove')) {
                return;
            }

            Modals.previewVideo(this.attachment_info.file_content);
        },

        onTogglePublic: function(e) {
            var internal = $(e.currentTarget).prop('checked');

            if (internal && !Cache.account.hasFeature('team_comments')) {
                Modals.unlockFeature();
                return;
            }

            this.is_public = !internal;

            if (this.is_public) {
                this.$el.removeAttr('data-internal');
            } else {
                this.$el.attr('data-internal', 1);
            }

            this.renderCommentStatusCheckbox();
        },

        onPaste: function(e) {
            e.preventDefault();

            try {
                var text = (e.originalEvent || e).clipboardData.getData('text/plain');
                document.execCommand('insertText', false, text);
            } catch(e) {
            }
        },

        onKeyup: function(e) {
            if (e.keyCode === 27) {
                this.trigger('close');
                return;
            }

            // clean up the extra <br> tag
            if (this.$el.find('.message-editor').html() === '<br>') {
                this.$el.find('.message-editor').html('');
                return;
            }

            try {
                this.comment_selection = window.getSelection().getRangeAt(0);
            } catch(e) {
                this.comment_selection = null;
            }
        },

        onSubmit: function(e) {
            this.trigger('submit', this.get());
        },

        onToggleCommentTemplate: function(e) {
            this.views.comment_template.reset();
        }
    },

    event_handlers: {
        handleFiles: function(files) {
            this.$el.find('.dnd-dropzone').hide();

            if (files.length === 0) {
                return;
            }

            if (this.attachment_info.file_name) {
                return;
            }

            var result = Util.readFile(files[0], 10, (file_name, file_type, file_content) => {
                this.renderAttachment(file_name, file_type, file_content);
            });

            if (result !== true) {
                UI.error(result);
            }
        },

        handleDragEnter: function() {
            this.$el.find('.dnd-dropzone').show();
        },

        handleDragLeave: function(event) {
            if (event.target === this.$el.find('.dnd-dropzone').get(0)) {
                this.$el.find('.dnd-dropzone').hide();
            }
        },

        handleCommentInsert: function(content) {
            this.$el.find('.message-editor').focus();

            const replacements = {};

            if (this.feedback) {
                const reporter = this.feedback.getReporter(Cache.user);
                replacements['feedback_link'] = window.location.origin + '/viewer/' + Cache.account.id + '/' + this.feedback.get('project_id') + '/' + this.feedback.escape('share_key') + '/';
                replacements['reporter_name'] = reporter?.name || reporter?.email || '';
                replacements['user_name'] = Cache.user.get(Cache.real_user_id).get('name') || Cache.user.get(Cache.real_user_id).get('email') || '';
            }

            // handle wildcard replacement
            content = this.replaceWildcard(content, replacements);

            // replace line breaks with <br>
            content = content.replace(/\n/g, '<br>');

            var _fallback = () => {
                var comment = this.$el.find('.message-editor').html();
                comment = comment.replace(/<br>$/, '');
                if (comment) {
                    comment += '<br>';
                }
                comment += content;
                this.$el.find('.message-editor').html(comment);
                this.placeCaretAtEnd();
            };

            _fallback();
            this.$el.find('.comment-template').hide();
        },
    },

    initialize: function(options) {
        this.embed             = options.embed;
        this.has_submit        = !!options.has_submit;
        this.has_public_toggle = !!options.public_toggle;
        this.has_attachment    = !!options.attachment;
        this.submit_text       = options.submit_text || 'Submit';
        this.placeholder       = options.placeholder || '';
        this.show_tools        = !!options.show_tools;
        this.disabled          = !!options.disabled;
        this.disable_dnd       = !!options.disable_dnd;
        this.new_idea          = !!options.new_idea;
        this.feedback_id       = options?.feedback_id;

        if (this.model) {
            this.is_public = this.model.get('is_public');
        }

        if (!Cache.account.hasFeature('team_comments')) {
            this.is_public = true;
        }

        if (this.feedback_id) {
            this.feedback = Cache.feedback.get(this.feedback_id);
        }

        this.is_access_checkbox_disabled = this.model && !this.model.get('is_public');

        var member = Cache.workspace_member.findWhere({ user_id: Cache.real_user_id });

        if (member) {
            var access = member.hasAccess(Constants.ACCESS_PUBLIC_COMMENT, Cache.portal.at(0).get('project_id'));

            if (!access) {
                this.is_access_checkbox_disabled = true;
                this.is_public = false;
            }
        }

        if (!this.has_public_toggle) {
            this.is_public = true;
        }

        if (!this.disable_dnd) {
            this.uploader = new Dnd_File_Uploader(
                this.event_handlers.handleFiles.bind(this),
                this.event_handlers.handleDragEnter.bind(this),
                undefined,
                this.event_handlers.handleDragLeave.bind(this)
            )
        }

        this.views.comment_template = new View_Comment_Template();
        this.listenTo(this.views.comment_template, 'comment::insert',  this.event_handlers.handleCommentInsert.bind(this));
    },

    onEmojiSelect: function(emoji) {
        this.$el.find('.message-editor').focus();

        var _fallback = function() {
            var comment = this.$el.find('.message-editor').html();
            comment = comment.replace(/<br>$/, '');
            comment += emoji;
            this.$el.find('.message-editor').html(comment);
            this.placeCaretAtEnd();
        }.bind(this);

        if (this.comment_selection) {
            try {
                this.comment_selection.deleteContents();
                this.comment_selection.insertNode(document.createTextNode(emoji));
                this.comment_selection.collapse(false);

                var sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(this.comment_selection);
            } catch (e) {
                _fallback();
            }
        } else {
            _fallback();
        }

        this.views.emoji.hide();
    },

    placeCaretAtEnd: function() {
        var el = this.$el.find('.message-editor').get(0);

        el.focus();

        if (typeof window.getSelection != 'undefined' && typeof document.createRange != 'undefined') {
            var range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(false);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (typeof document.body.createTextRange != 'undefined') {
            var textRange = document.body.createTextRange();
            textRange.moveToElementText(el);
            textRange.collapse(false);
            textRange.select();
        }
    },

    replaceWildcard: function(content, replacements) {
        return content.replace(/%%(.*?)%%/g, function(match, key) {
            return replacements[key] !== undefined ? replacements[key] : match;
        });
    },

    get: function() {
        var comment = this.$el.find('.message-editor').html();

        var temp_element = $('<div>').html(comment);
        temp_element.find('.at-name').each(function() {
            var user_id = $(this).attr('userid');
            this.outerHTML = '@@:' + user_id + ':' + $(this).text() + '@@';
        });

        comment = temp_element.html();

        // sanitize
        comment = comment.replace(/<br\/?>/gi, '\n');
        comment = comment.replace(/(<([^>]+)>)/gi, '');
        comment = comment.replace(/&nbsp;/gi, ' ');
        comment = comment.replace(/&lt;/gi, '<');
        comment = comment.replace(/&gt;/gi, '>');
        comment = comment.replace(/&amp;/gi, '&');
        comment = comment.replace(/&quot;/gi, '"');

        comment = comment.trim();

        return {
            comment    : comment,
            attachment : this.attachment_info,
            is_public  : this.is_public
        };
    },

    focus: function() {
        this.$el.find('.message-editor').focus();
    },

    setText: function(text, reset_attachment) {
        this.$el.find('.message-editor').text(text);

        if (reset_attachment) {
            this.resetAttachment();
        }
    },

    enable: function() {
        this.$el.find('.message-editor').prop('contenteditable', true).removeClass('disabled');
        this.$el.find('.editor-submit').prop('disabled', false).removeClass('loading');
    },

    disable: function() {
        this.$el.find('.message-editor').prop('contenteditable', false).addClass('disabled');
        this.$el.find('.editor-submit').prop('disabled', true).addClass('loading');
    },

    resetAttachment: function() {
        this.$el.find('.attachment-preview').html('');
        this.attachment_info = {};

        this.$el.find('.attach-launcher').prop('disabled', false);
    },

    renderAttachment: function(file_name, file_type, file_content) {
        this.$el.find('.attachment-preview').removeClass('attachment-preview-video');

        if (Util.isImage(file_name)) {
            this.$el.find('.attachment-preview').html('<img src="' + file_content + '">' +
                                                        '<button class="attachment-remove" type="button">' +
                                                            '<i class="fas fa-times-circle"></i>' +
                                                        '</button>');
        } else if (Util.isVideo(file_name)) {
            this.$el.find('.attachment-preview').html('<video src="' + file_content + '"></video>' +
                                                        '<button class="attachment-remove" type="button">' +
                                                            '<i class="fas fa-times-circle"></i>' +
                                                        '</button>' +
                                                        '<button class="video-play" type="button">' +
                                                            '<i class="fas fa-play-circle"></i>' +
                                                        '</button>');

            this.$el.find('.attachment-preview').addClass('attachment-preview-video');
        } else {
            this.$el.find('.attachment-preview').html('<span>' + Util.htmlEntities(file_name) + '</span>' +
                                                        '<button class="attachment-remove" type="button">' +
                                                            '<i class="fas fa-times-circle"></i>' +
                                                        '</button>');
        }

        this.attachment_info = {
            file_name    : file_name,
            file_type    : file_type,
            file_content : file_content
        };

        this.$el.find('.attach-launcher').prop('disabled', true);
    },

    renderCommentStatusCheckbox: function() {
        var id = this.model ? this.model.id : 0;

        this.$el.find('.comment-status-launcher').html(
            '<input type="checkbox" id="internal-' + id + '"' + (this.is_public ? '' : ' checked') + (this.is_access_checkbox_disabled ? ' disabled' : '') + '>' +
            '<label for="internal-' + id + '"><i class="fas fa-lock info"></i> <span class="text-info">Internal</span></label>'
        );
    },

    render: function() {
        var content = '';

        content +=
        '<div class="message-editor" contenteditable="true" placeholder="' + Util.htmlEntities(this.placeholder) + '"></div>' +

        (this.show_tools ?
        '<div class="action-bar">' +
            '<div class="attachment-preview"></div>' +
            '<div class="options">' +
                (this.has_public_toggle && Cache.account.hasFeature('team_comments') ? '<span class="comment-status-launcher"></span>' : '') +
                (this.new_idea || !Cache.real_user_id || this.embed === 'widget' ? '' :
                '<div class="comment-template-button-dropdown button-dropdown button-dropdown-left" data-append="true" data-flip="true" data-offset="-112,4">' +
                    '<button type="button" class="template-launcher"><i class="fa-regular fa-file-lines"></i></button>' +
                    '<div class="comment-template dropdown-box"></div>' +
                '</div>') +
                '<button type="button" class="emoji-launcher"></button>' +
                (this.has_attachment ?
                '<button type="button" class="attach-launcher"><i class="far fa-paperclip"></i></button>' : '') +
            '</div>' +
            '<div class="region-emoji"></div>' +


            '<div class="send">' +
                (this.has_submit ?
                '<button class="editor-submit text-info square round small tooltip" data-title="' + this.submit_text + '" type="button"><i class="fas fa-paper-plane-top"></i></button>' : '')+
            '</div>' +
        '</div>' : '');
        if (!this.disable_dnd) {
            content += '<div class="dnd-dropzone" style="display: none"></div>';
        }

        this.$el.html(content);

        this.renderCommentStatusCheckbox();

        if (this.disabled) {
            this.disable();
        }

        if (!this.is_public) {
            this.$el.attr('data-internal', 1);
        }

        if (!this.disable_dnd) {
            this.uploader.setupDropArea(this.$el.get(0));
        }

        if (Cache.real_user_id && !Cache.app.isClient()) {
            this.views.comment_template.render().$el.appendTo(this.$el.find('.comment-template'));
        }

        return this;
    }
});